class BadgeEssential extends HTMLElement {
  connectedCallback() {
    this.innerHTML = this.dataset.small ? window.badgeEssentialSmall : window.badgeEssential;

    if (this.dataset.small) {
      this.querySelector(".badge-icon-desktop")?.remove();
      this.querySelector(".badge-icon-mobile")?.classList.remove("md:hidden");
    }
  }
}

customElements.define("badge-essential", BadgeEssential);
